(function () {
  const updateCurrentYear = function () {
    const currentYear = String(new Date().getFullYear());

    document.querySelectorAll('[data-current-year]').forEach((yearElement) => {
      yearElement.textContent = currentYear;
      yearElement.setAttribute('datetime', currentYear);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCurrentYear, { once: true });
  } else {
    updateCurrentYear();
  }
})();
